import { render } from "./WebSites.vue?vue&type=template&id=60a6639f&scoped=true"
import script from "./WebSites.vue?vue&type=script&lang=js"
export * from "./WebSites.vue?vue&type=script&lang=js"

import "./WebSites.vue?vue&type=style&index=0&id=60a6639f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a6639f"]])

export default __exports__